import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import pl from "./pl";
import de from "./de"
import sk from "./sk"
import et from "./et"
import cs from "./cs";
import lt from "./lt";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  pl,
  en,
  de,
  sk,
  et,
  cs,
  lt
} as const;

const setDocumentTitle = () => {
  document.title = i18n.t("nav.appTitle", { ns: "admin", defaultValue: document.title });
};
i18n.on("initialized", setDocumentTitle);
i18n.on("languageChanged", setDocumentTitle);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    interpolation: {
      // React escapes rendered text itself; escaping here turns e.g. "Z11684/2026" into "Z11684&#x2F;2026"
      escapeValue: false
    }
  });

export default i18n;